import { computed, ref } from 'vue'
import { defineStore } from 'pinia'
import type { ErrorStatus } from '@/views/ErrorView.vue'

// WHY: Error pages are rendered in place of the current route so the URL stays untouched.
// The error is intentionally kept across navigations; only a reload recovers from it.
export const useErrorPageStore = defineStore('errorPage', () => {
    const status = ref<ErrorStatus | null>(null)
    const fullscreen = ref(false)
    // WHY: Follow-up request errors are noise while the 500 page already explains the failure.
    const suppressGlobalErrorToast = computed(() => status.value === 500)

    function showError(errorStatus: ErrorStatus, options: { fullscreen?: boolean } = {}) {
        status.value = errorStatus
        fullscreen.value = options.fullscreen ?? false
    }

    return { status, fullscreen, suppressGlobalErrorToast, showError }
})
